import home from '../Pages/Home/definition.json'
import exhibitions from '../Pages/Exhibitions/definition.json'
import news from '../Pages/News/definition.json'
import events from '../Pages/Events/definition.json'
import frames from '../Pages/Frames/definition.json'
import materials from '../Pages/Materials/definition.json'
import virtuale from '../Pages/LiveExhibition/definition.json'

const contents = [home, exhibitions, news, events, frames, materials, virtuale]

export const search = (term) => {
    return contents.map((c, k) => search_in_content(c, term));
}

const search_in_content = (c, term) => {
    let results = []
    Object.keys(c).map(k => {
        if (k !== 'page') {
            let inner = c[k]
            return search_in_def(c.page, inner, term, results);
        } else {
            return null
        }
    })
    return results;
}

const filter = (t) => {
    if (t.includes("_") || t.includes("img")) {
        return false;
    } else { return true };
}

const replaceAll = (str, strReplace, strWith) => {
    var esc = strReplace.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
    var reg = new RegExp(esc, 'ig');
    return str.replace(reg, strWith);
};

const search_in_def = (page, c, term, results) => {
    return Object.keys(c).map((ik, v) => {
        let type = typeof c[ik];
        let key = c["key"]
        if (type === 'string' && filter(c[ik])) {
            let t = c[ik].toLowerCase()
            if (t.includes(term.toLowerCase())) {
                let match = replaceAll(c[ik], term, "<b>" + term + "</b>")
                return results.push({ page: page, match: match, key: key });
            } else {
                return null
            }
        } else if (type === 'object') {
            return search_in_def(page, c[ik], term, results)
        } else {
            return null
        }
    })
}
